export default __webpack_public_path__ + "static/media/feature-tick.ff246dcf.png";